import { render, staticRenderFns } from "./LittleBuddhaSalesForm.vue?vue&type=template&id=27092558&"
import script from "./LittleBuddhaSalesForm.vue?vue&type=script&lang=js&"
export * from "./LittleBuddhaSalesForm.vue?vue&type=script&lang=js&"
import style0 from "./LittleBuddhaSalesForm.vue?vue&type=style&index=0&id=27092558&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports